/* eslint-disable no-underscore-dangle */
<template>
   <span @click="click"
   :class="['text', textTheme,hasTextMargin ? 'margin-text' : '']"
   :style="themeStyle">{{textValue}}</span>
</template>

<script>

export default {
  props: {
    textValue: {
      type: String,
      default: '',
    },
    textTheme: {
      type: String,
      default: 'gray',
    },
    textStyle: {
      type: Object,
      default() {
        return {};
      },
    },
    hasTextMargin: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    themeStyle() {
      let style = {};
      const { textStyle } = this;
      if (textStyle && textStyle.fontSize) {
        style = Object.assign(style, { fontSize: `${textStyle.fontSize}px`, height: `${textStyle.fontSize * 1.2}px` });
      }
      if (textStyle && textStyle.color) {
        style = Object.assign(style, { color: textStyle.color });
      }
      style = Object.assign(style, this.textStyle);
      return style;
    },
  },
  methods: {
    click(e) {
      this.$emit('textclick', e);
    },
  },
};

</script>

<style scoped>
    .text {
        display: flex;
        font-size: 28px;
        line-height: 40px;
        color: #3d3d3d;
    }

    .black {
        color: #3D3D3D;
    }

    .yellow {
        color: #EE9900;
    }

    .blue {
        color: #008aff;
    }

    .gray {
        color: #999;
    }

    .red {
        color: #FF5000;
    }

    .margin-text {
        margin-right: 6px;
    }
</style>
